export default {
  applyTags: "Apply Tags...",
  parseProducts: "Batch pad add products...",
  install: "Install",
  deleteDataFile: "Delete DataF ile...",
  emailDataFile: "Email Data File...",
  printDataFile: "Print Data File...",
  uploadToSupport: "Send to EMUN Support...",
  size: "Size",
  uploaded: "Uploaded",
  lastWriteTimeUtc: "Last Modified"
};
